export const sendSelectTypeOptions = [
  { sendSelectType: 1, name: "门店自提", shipType: "shop" },
  { sendSelectType: 2, name: "快递配送", shipType: "same" },
  { sendSelectType: 3, name: "商家配送", shipType: "delivery" },
  { sendSelectType: 4, name: "无需物流", shipType: "logistic" }
];
